import CommentPanel from './CommentPanel';

export default CommentPanel;
